import { PRIMARY_API_HELPER_ARTICLE_ID } from "@shared/features/settings/subscription/constants";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { AnalyticsPageName, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const PrimaryApiHelperTooltip = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);

  return (
    <HelperTooltip
      analyticsPageName={AnalyticsPageName.BILLING}
      analyticsFieldName={t("tooltips.primary_api_title")}
      description={t("tooltips.primary_api_description")}
      articleId={PRIMARY_API_HELPER_ARTICLE_ID}
      containerStyle={{ marginLeft: 6 }}
    />
  );
};

export default PrimaryApiHelperTooltip;
